import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import './PaginatedItems.css';
import { useLocation } from "react-router-dom";

function PaginatedItems(props) {
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [forcePage, setForcePage] = useState(0);
  const [oldKeys, setOldKeys] = useState([]);

  let location = useLocation();

  useEffect(() => {
    if (location.key !== 'default') {
      const oldKeysCopy = Object.assign([], oldKeys);
      if (!oldKeysCopy.includes(location.key)) {
        if (props.page !== 0) {
          if (oldKeysCopy.length !== 0) {
            const pathName = window.location.pathname;
            window.history.replaceState({}, null, `${pathName}?page=${props.page + 1}`);
            window.history.pushState({}, null, pathName);
          }
          props.setPage(0);
        }
        oldKeysCopy.push(location.key);
        setOldKeys(oldKeysCopy);
      }
    }
  }, [location.key, oldKeys, props]);

  useEffect(() => {
    setForcePage(props.page);
    const newOffset = (props.page * props.itemsPerPage) % props.items.length;
    setItemOffset(newOffset);
    const endOffset = itemOffset + props.itemsPerPage;
    setCurrentItems(props.items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(props.items.length / props.itemsPerPage));
  }, [props.items, itemOffset, props.itemsPerPage, props.page]);

  const handlePageChange = (event) => {
    updateUrlBasedOnPageNumber(event.selected);
    props.setPage(event.selected);
  };

  function updateUrlBasedOnPageNumber(num) {
    const pathName = window.location.pathname;                //  /news
    const newUrl = (num !== 0) ? `${pathName}?page=` + (+num + 1) : `${pathName}`;
    window.history.pushState({}, null, newUrl);
  }

  function isPaginationEnabled() {
    return pageCount > 0;
  }

  return (
    <>
      <props.func newsItems={currentItems} page={props.page} sumNumbers={props.sumNumbers}/>
      {isPaginationEnabled() &&
        <ReactPaginate
          breakLabel="..."
          nextLabel="вперед>"
          onPageChange={handlePageChange}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          breakClassName="paginated-items__break"
          pageCount={pageCount}
          previousLabel="<назад"
          renderOnZeroPageCount={null}
          containerClassName="paginated-items__container"
          pageClassName="paginated-items__page"
          previousLinkClassName="paginated-items__previous-link"
          nextLinkClassName="paginated-items__next-link"
          previousClassName="paginated-items__previous"
          nextClassName="paginated-items__next"
          activeClassName="paginated-items__active"
          disabledLinkClassName="paginated-items__disabled-link"
          forcePage={forcePage}
        />
      }
    </>
  );
}

export default PaginatedItems;